module.exports = __webpack_public_path__ + "static/Logos-4813172eaf4c3898fea8fcce593be705.png";